import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToSection } from "@/lib/api";

const NAV = [
  { label: "Nasıl Çalışır?", id: "nasil-calisir" },
  { label: "Avantajlar", id: "avantajlar" },
  { label: "Partner Ol", id: "kimler" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/75 backdrop-blur-xl border-b border-white/50 shadow-[0_4px_30px_-12px_rgba(11,59,117,0.15)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo onClick={() => go("hero")} />

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="text-sm font-medium text-[#344054] hover:text-[#1677FF] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="header-cta"
            onClick={() => go("basvuru")}
            className="rounded-full bg-[#1677FF] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_-6px_rgba(22,119,255,0.6)] hover:bg-[#0B3B75] transition-colors"
          >
            Partner Başvurusu
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/70 border border-white/60 text-[#172033]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menü"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-100 px-5 py-4 space-y-1">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`mobile-nav-${n.id}`}
              onClick={() => go(n.id)}
              className="block w-full text-left py-3 text-base font-medium text-[#344054]"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="mobile-header-cta"
            onClick={() => go("basvuru")}
            className="mt-2 w-full rounded-full bg-[#1677FF] px-5 py-3.5 text-base font-semibold text-white"
          >
            Partner Başvurusu
          </button>
        </div>
      )}
    </header>
  );
};
